var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRabby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 16C0.833008 7.43959 7.77259 0.5 16.333 0.5C24.8934 0.5 31.833 7.43959 31.833 16C31.833 24.5604 24.8934 31.5 16.333 31.5C7.77259 31.5 0.833008 24.5604 0.833008 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 16C0.833008 7.43959 7.77259 0.5 16.333 0.5C24.8934 0.5 31.833 7.43959 31.833 16C31.833 24.5604 24.8934 31.5 16.333 31.5C7.77259 31.5 0.833008 24.5604 0.833008 16Z",
    stroke: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14156_37369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5145 17.1018C26.2473 15.4628 22.6034 10.8617 19.1179 8.96598C16.9197 7.48494 14.6423 7.68241 14.167 8.33407C13.157 9.75586 17.5336 10.9802 20.4646 12.3822C19.8308 12.6587 19.2367 13.1524 18.9001 13.7645C17.8109 12.5797 15.4146 11.5529 12.6025 12.3822C10.7013 12.9352 9.13681 14.2582 8.52289 16.2329C8.38426 16.1737 8.20603 16.1342 8.0476 16.1342C7.39408 16.1342 6.85938 16.6674 6.85938 17.319C6.85938 17.9707 7.39408 18.5039 8.0476 18.5039C8.16642 18.5039 8.54269 18.4249 8.54269 18.4249L14.6423 18.4644C12.2064 22.3348 10.2656 22.8877 10.2656 23.5591C10.2656 24.2305 12.1074 24.0528 12.8005 23.7961C16.1275 22.6113 19.6922 18.879 20.3061 17.8127C22.8806 18.1484 25.0392 18.1681 25.5145 17.1018Z",
    fill: "url(#paint0_linear_14156_37369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4844 12.3822C20.623 12.323 20.6032 12.1255 20.5636 11.9675C20.4844 11.6121 18.9991 10.1508 17.6128 9.49915C15.7117 8.61053 14.3254 8.65002 14.1274 9.06471C14.5036 9.8546 16.3058 10.5852 18.1673 11.3751C18.9397 11.6911 19.7516 12.0268 20.4844 12.3822Z",
    fill: "url(#paint1_linear_14156_37369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0683 20.3206C17.692 20.1824 17.2563 20.0441 16.7613 19.9256C17.2762 18.9975 17.395 17.5955 16.8999 16.7266C16.2067 15.5023 15.3354 14.8506 13.2956 14.8506C12.1866 14.8506 9.17641 15.2258 9.117 17.7337C9.117 17.9904 9.117 18.2274 9.13681 18.4644H14.6423C13.9095 19.6294 13.2164 20.4983 12.6025 21.15C13.3352 21.3277 13.9293 21.4857 14.4838 21.6436C14.9987 21.7819 15.4938 21.9004 15.9889 22.0386C16.7415 21.4857 17.4544 20.8933 18.0683 20.3206Z",
    fill: "url(#paint2_linear_14156_37369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44368 18.1681C8.66152 20.0639 9.75072 20.8143 11.9687 21.0315C14.1868 21.2487 15.4542 21.1105 17.1375 21.2487C18.5436 21.3672 19.811 22.0978 20.2665 21.8411C20.6824 21.6239 20.4448 20.8143 19.8903 20.3008C19.1575 19.6294 18.1475 19.1753 16.385 18.9975C16.7415 18.0299 16.6424 16.6674 16.0879 15.9367C15.2958 14.8704 13.8303 14.3964 11.9687 14.5939C10.028 14.8309 8.16642 15.7985 8.44368 18.1681Z",
    fill: "url(#paint3_linear_14156_37369)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14156_37369",
    x1: 10.4368,
    y1: 15.9339,
    x2: 22.1555,
    y2: 15.9339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8797FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14156_37369",
    x1: 31.7608,
    y1: 39.6691,
    x2: -6.57083,
    y2: 14.8068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B22A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5156D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14156_37369",
    x1: 26.1507,
    y1: 20.9197,
    x2: 6.67791,
    y2: 10.4745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B1E8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6FFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14156_37369",
    x1: 13.5081,
    y1: 16.3132,
    x2: 16.6337,
    y2: 20.9274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8898FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9839,
    stopColor: "#5F47F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14156_37369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.33301 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabby);
export default __webpack_public_path__ + "static/media/rabby.f1b6ec59abf68f514093a55bed58777c.svg";
export { ForwardRef as ReactComponent };